import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $asset, $http } from '@/axios';
import store from '@/store';

// 查询型材列表
export const querySectionBars: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSectionBars', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/data/ue/section/search', payload);
    commit('setSectionBars', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setSectionBars', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询型材详情
export const querySectionBarDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSectionBarDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/data/ue/section/${payload}/detail`);
    commit('setSectionBarDetail', { data: res, loading: false });
  } catch (e) {
    commit('setSectionBarDetail', { data: null, loading: false });
  }
};

// 编辑型材
export const editSectionBar: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/section/saveorupdate', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除型材
export const deleteSectionBar: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/ue/section/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
